// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_moderatorWrapper__2E9Ei {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.styles_moderatorWrapper__2E9Ei h3 {
  font-size: 20px;
  font-weight: 700;
  color: #6ba7a8;
  padding: 12px 24px;
}
.styles_moderatorWrapper__2E9Ei .styles_moderator__Zee-A {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px 8px 8px 24px;
  border-radius: 8px;
  max-width: max-content;
}
.styles_moderatorWrapper__2E9Ei .styles_moderator__Zee-A.styles_editable__6QDBu {
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.styles_moderatorWrapper__2E9Ei .styles_moderator__Zee-A:hover {
  cursor: pointer;
}
.styles_moderatorWrapper__2E9Ei .styles_moderator__Zee-A .styles_image__jbOVO {
  width: 16px;
  height: auto;
  transition: opacity 0.2s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/components/reusable/SingleTranscript/TranscriptModerator/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACJ;AAEE;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAAJ;AAEI;EACE,iDAAA;AAAN;AAGI;EACE,eAAA;AADN;AAII;EACE,WAAA;EACA,YAAA;EACA,oCAAA;AAFN","sourcesContent":[".moderatorWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  h3 {\n    font-size: 20px;\n    font-weight: 700;\n    color: #6ba7a8;\n    padding: 12px 24px;\n  }\n\n  .moderator {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    padding: 8px 8px 8px 24px;\n    border-radius: 8px;\n    max-width: max-content;\n\n    &.editable {\n      box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n    }\n\n    &:hover {\n      cursor: pointer;\n    }\n\n    .image {\n      width: 16px;\n      height: auto;\n      transition: opacity 0.2s ease-in-out;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"moderatorWrapper": `styles_moderatorWrapper__2E9Ei`,
	"moderator": `styles_moderator__Zee-A`,
	"editable": `styles_editable__6QDBu`,
	"image": `styles_image__jbOVO`
};
export default ___CSS_LOADER_EXPORT___;
